import React from 'react';
import { Grid } from '@mui/material';
import RedirectorComponent from '../../Redirector/RedirectorComponent';
import PathfinderComponent from '../../PathFinder/PathfinderComponent';
import UGLComponent from '../../UGL/UGLComponent';
import PlaycheckComponent from '../../PlayCheck/PlaycheckComponent';
import HelpfilesComponent from '../../HelpFiles/HelpfilesComponent';
import GameFlexLaunchComponent from '../../GameFlexLaunch/GameFlexLaunchComponent';

const LaunchTabContent = ({
    tabValue,
    selectedServer,
    showFrame
}) => {
    const renderTabContent = () => {
        switch (tabValue) {
            case 0:
                return (
                    <RedirectorComponent
                        selectedServer={selectedServer}
                        demo={selectedServer.demo}
                        gameFallback={selectedServer.gameFallback}
                        showFrame={showFrame}
                    />
                );
            case 1:
                return (
                    <GameFlexLaunchComponent
                        selectedServer={selectedServer}
                        demo={selectedServer.demo}
                        gameFallback={selectedServer.gameFallback}
                        showFrame={showFrame}
                    />
                );
            case 2:
                return (
                    <PathfinderComponent
                        selectedServer={selectedServer}
                        demo={selectedServer.demo}
                        gameFallback={selectedServer.gameFallback}
                        showFrame={showFrame}
                    />
                );
            case 3:
                return (
                    <UGLComponent
                        selectedServer={selectedServer}
                        demo={selectedServer.demo}
                        gameFallback={selectedServer.gameFallback}
                        showFrame={showFrame}
                    />
                );
            case 4:
                return <PlaycheckComponent selectedServer={selectedServer} />;
            case 5:
                return <HelpfilesComponent selectedServer={selectedServer} />;
            default:
                return null;
        }
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                {renderTabContent()}
            </Grid>
        </Grid>
    );
};

export default LaunchTabContent;